import React from "react"
import styles from "./style.css"
import iconDone from "../../../../../assets/svg/fixed-icon-done.svg"
import iconInfo from "../../../../../assets/svg/fixed-voice-info-green.svg"
import PropTypes from "prop-types"

const StepCard = ({ children, formCurrent, onChangeSelect, type, tab }) => {
  const { id, title, title2, icon, isCompleted, isEditing } = formCurrent
  const definedTitle = type !== "Portabilidade" ? title : title2
  const isAmountOfNumbers = id === "amountOfNumbers"

  const onKeyEnter = (event) => {
    if (event.key === "Enter") {
      onChangeSelect(id)
    }
  }

  return (
    <div
      className={`${styles.box} ${
        isEditing || isCompleted ? styles.box_selected : ""
      }`}
      onClick={() => onChangeSelect(id)}
      onKeyDown={(e) => onKeyEnter(e)}
      tabIndex={tab}
    >
      <div
        className={`${styles.title} ${isEditing ? styles.title_selected : ""}
           ${isCompleted ? styles.title_completed : ""}`}
      >
        <div
          className={`${styles.title_text} ${
            isEditing && isAmountOfNumbers ? styles.flex_element : ""
          }`}
        >
          {definedTitle}
          {isEditing && isAmountOfNumbers && (
            <div className={styles.tooltip}>
              <div className={styles.tooltiptext}>
                O limite máximo para solicitação é de 20 números. Para
                solicitações com valores acima do limite,
                {/* eslint-disable-next-line react/no-unescaped-entities */}
                utilize a funcionalidade "Análise do especialista".
              </div>
              <img
                className={styles.img_style}
                width={25}
                src={iconInfo}
                alt="info icon"
              />
            </div>
          )}
        </div>
        {isCompleted ? (
          <img src={iconDone} alt="icon done" />
        ) : (
          <div
            className={`
           ${styles.circle}
           ${isEditing ? styles.circle_selected : styles.circle_default}`}
          >
            {icon}
          </div>
        )}
      </div>

      {isEditing && children}
    </div>
  )
}

StepCard.propTypes = {
  children: PropTypes.node.isRequired,
  onChangeSelect: PropTypes.func.isRequired,
  formCurrent: PropTypes.object,
  type: PropTypes.string,
  tab: PropTypes.number.isRequired
}

export default React.memo(StepCard)



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/NewSale/StepCard/index.js